import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MasksIcon(props: IconProps) {
    return <Icon {...props} iconKey={"masks"}/>
}
